import { render } from "./userNotifications.vue?vue&type=template&id=5a7b9c54&scoped=true"
import script from "./userNotifications.vue?vue&type=script&lang=js"
export * from "./userNotifications.vue?vue&type=script&lang=js"

import "./userNotifications.vue?vue&type=style&index=0&id=5a7b9c54&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7b9c54"]])

export default __exports__